import { getCheckoutClient } from "../../../config/CheckoutClient";
import { addServerErrors, setCheckoutOverlay } from "../../../actions/ui";
import { createReservationIfNotExists, fetchReservation, reservationCreated, setReservationData, deleteReservation } from "../../../actions/reservation";
import { setPriceLevels, setEventPriceLevels, setProducts, updatePriceLevels, setBundles } from '../../../actions/event';
import { isReservationContentFree, reservationActive } from '../../../selectors/reservation';
import { getSelectedEvent } from '../../../selectors/event';

import { setListingItem, getListingItem } from "../../../../listing/helpers/storage";
import { setInsurancePolicy } from "../../../views/insurance/actions/insurance";
import { isKioskMode } from '../../../selectors/ui';
import { serializeToUrl } from '../../../helpers/helpers';
import { submitReserveCoupon } from '../../../actions/reservedSeating';
import { getReserveCouponUsage } from '../../../selectors/reserved-seating';
import { wrappedGet } from "../../../helpers/fetch";
import { showPresaleCouponForm } from '../selectors/coupon';
import { navigate } from '../../../helpers/navigationService';
import { TICKETS_DISPLAY_LIST } from "../../../reducers/ui";
import { isDynamicListing } from "@checkout-b/checkout/selectors/dynamic-listing";
import { getIsCheckoutSSO } from '../../../selectors/auth';
import { refetchMember } from '../../member/actions/member';

export function setCouponCode(code) {
    return { type: "SET_COUPON_CODE", code };
}

export function addCouponCode(code) {
  return { type: "ADD_COUPON_CODE", code };
}

export function clearCouponCodes() {
  return {type: "CLEAR_COUPON_CODES"};
}

export function setCouponInput(code) {
    return { type: "SET_COUPON_INPUT", code };
}

export function removeCouponCode(code) {
    return { type: "REMOVE_COUPON_CODE", code };
}

export function setAutoCouponAmount(autoCouponAmount) {
    return { type: "SET_AUTO_COUPON_AMOUNT", autoCouponAmount };
}

export function setPresaleCode(presaleCode) {
    return { type: "SET_PRESALE_CODE", presaleCode };
}

export function setCouponData(couponData) {
    return { type: "SET_COUPON_DATA", couponData }
}

export function setShowError(showError) {
    return { type: "SET_SHOW_ERROR", showError };
}

export function setShowSuccess(showSuccess) {
    return { type: "SET_SHOW_SUCCESS", showSuccess };
}

export function setShowWarning(showWarning) {
    return { type: "SET_SHOW_WARNING", showWarning };
}

export function setIsPresaleValid(isPresaleValid) {
    return { type: "SET_IS_PRESALE_VALID", isPresaleValid }
}

export function setIsPresaleApplied(isPresaleCodeApplied) {
    return { type: "SET_IS_PRESALE_APPLIED", isPresaleCodeApplied }
}

export function setAccessCode(accessCode) {
    return { type: "SET_ACCESS_CODE", accessCode };
}

export function setIsAccessCodeValid(isAccessCodeValid) {
    return { type: "SET_IS_ACCESS_CODE_VALID", isAccessCodeValid }
}

export function setIsAccessCodeApplied(isAccessCodeApplied) {
    return { type: "SET_IS_ACCESS_CODE_APPLIED", isAccessCodeApplied }
}

export function setShowAccessCodeError(showAccessCodeError) {
    return { type: "SET_SHOW_ACCESS_CODE_ERROR", showAccessCodeError }
}

export function setShowAccessCodeSuccess(showAccessCodeSuccess) {
    return { type: "SET_SHOW_ACCESS_CODE_SUCCESS", showAccessCodeSuccess }
}

export function couponSubmitted(code) {
    return { type: "COUPON_SUBMITTED", code }
}

export function setUnlockedPresaleEvent(id) {
    return { type: "SET_UNLOCKED_PRESALE_EVENT", id };
}

export function setAccessInventory(val) {
    return { type: "SET_ACCESS_INVENTORY", val };
}

export const setReserveCouponUsages = val => {
    return { type: "SET_RESERVE_COUPON_USAGES", val };
}

export const setInviteCouponUsages = val => {
    return { type: "SET_INVITE_COUPON_USAGES", val };
}

export const setTaggableAccessCodeApplied = val => {
    return { type: "SET_TAGGABLE_ACCESS_CODE_APPLIED", val };
}

export const setTaggableReserveCodeApplied = val => {
    return { type: "SET_TAGGABLE_RESERVE_CODE_APPLIED", val };
}

export const setTaggableInvitationCodeApplied = val => {
    return { type: "SET_TAGGABLE_INVITATION_CODE_APPLIED", val };
}

export const setTaggablePresaleCodeApplied = val => {
    return { type: "SET_TAGGABLE_PRESALE_CODE_APPLIED", val };
}

export const setTaggableDiscountCodeApplied = val => {
    return { type: "SET_TAGGABLE_DISCOUNT_CODE_APPLIED", val };
}

export const setTaggableCouponLoading = val => {
    return { type: "SET_TAGGABLE_COUPON_LOADING", val };
}

export const setTaggableCodeError = val => {
    return { type: "SET_TAGGABLE_CODE_ERROR", val };
}

export const addAppliedPresaleCoupon = coupon => {
    return { type: "ADD_APPLIED_PRESALE_COUPON", coupon };
}

export const setAppliedPresaleCoupons = coupons => {
    return { type: "SET_APPLIED_PRESALE_COUPONS", coupons };
}

const getEventId = state => {
    return getSelectedEvent(state)?.event_id;
}

export const setCouponLoading = val => {
    return { type: "SET_COUPON_LOADING", val };
}

export function validateCoupon({
  code,
  force = false,
  forTaggableCoupon = false,
  submitAccessCoupon = true
}) {
    return (dispatch, getState) => {
        let state = getState();

        dispatch(couponSubmitted(code));

        let payload = serializeToUrl({
            code: code,
            eventId: getEventId(state),
            token: (state.reservation.token !== '') ? state.reservation.token : getListingItem(state.ui.listingSlug, "token")/*localStorage.getItem('token')*/,
            listingId: state.ui.listingId,
        });

        if (forTaggableCoupon) {
            dispatch(setTaggableCouponLoading(true));
        }else{
            dispatch(setCouponLoading(true));
        }

        return wrappedGet(state.ui.apiUrl + '/coupon-validation?' + payload).then((response) => {
            return response.json();
        }).then((data) => {
            dispatch(setCouponLoading(false));

            if (data.couponLimitReached) { // a different access coupon was already applied
                dispatch(setShowAccessCodeError(true));
                dispatch(setTaggableCouponLoading(false));
                return data;
            }

            if (data.isPlCode === true) { //access coupon
                if (isKioskMode(state)) {//do not allow access coupons for kiosk listings
                    dispatch(setTaggableCouponLoading(false));
                    dispatch(setShowError(true));
                } else if (data.valid === true) {
                    if (data.hasUsedCoupons === true) {
                        dispatch(setAccessCode(code));
                        dispatch(setIsAccessCodeValid(true));
                        dispatch(setIsAccessCodeApplied(true));
                        dispatch(getHiddenPriceLevels());
                    } else if (submitAccessCoupon) {
                        dispatch(setAccessCode(code));
                        dispatch(setIsAccessCodeValid(data.valid));
                        dispatch(submitPriceLevelCoupon(code, forTaggableCoupon));
                    }
                } else {
                    dispatch(setShowError(!data.valid));
                    dispatch(setTaggableCouponLoading(false));
                }
            } else {
                if (data.valid === true) {
                    dispatch(addCouponCode(code));
                    dispatch(setCouponCode(code));
                    dispatch(setShowSuccess(data.valid));
                    dispatch(setShowError(!data.valid));
                    dispatch(setCouponInput(""));
                    if (forTaggableCoupon) {
                        dispatch(setTaggableDiscountCodeApplied(true));
                    }
                } else {
                    dispatch(setShowError(true));
                    dispatch(setShowSuccess(false));
                }
                dispatch(setTaggableCouponLoading(false));
            }
            return data;
        }).catch(function (err) {
            dispatch(setCouponLoading(false));

            if (forTaggableCoupon) {
                dispatch(setTaggableCodeError(true));
                dispatch(setTaggableCouponLoading(false));
            }
            dispatch(setShowError(true));
            dispatch(setShowSuccess(false));

            return data;
        });
    }
}

export function validatePresaleCoupon({
  reload = null,
  force = false,
  forTaggableCoupon = false,
  coupon = null,
  ignoreError = false,
} = {}) {
    return (dispatch, getState) => {
        let state = getState();

        let payload = serializeToUrl({
            code: coupon || state.coupon.presaleCode,
            eventId: getEventId(state),
            listingId: state.ui.listingId,
        });

        if (forTaggableCoupon) {
            dispatch(setTaggableCouponLoading(true));
        }else{
            dispatch(setCouponLoading(true));
        }

        return wrappedGet(state.ui.apiUrl + '/presale-coupon-validation?' + payload).then((response) => {
            return response.json();
        }).then((data) => {
            dispatch(setCouponLoading(false));

            if (data.valid === true) {
                dispatch(setPriceLevels(data.price_levels));
                dispatch(setEventPriceLevels(getEventId(state), data.price_levels));
                if (data.products) dispatch(setProducts(data.products));
                if (data.bundles) dispatch(setBundles(data.bundles));
                dispatch(setPresaleCode(coupon || state.coupon.presaleCode));
                dispatch(setIsPresaleValid(data.valid));
                dispatch(setCouponInput(""));
                if (forTaggableCoupon) {
                    dispatch(setTaggablePresaleCodeApplied(true));
                    dispatch(setTaggableCouponLoading(false));
                }
                if (reload !== true) dispatch(submitPresaleCoupon()).catch(() => {});
            } else {
                if (ignoreError) {
                  return;
                }

                dispatch(setShowError(!data.valid));
                if (forTaggableCoupon) {
                    dispatch(setTaggableCodeError(true));
                    dispatch(setTaggableCouponLoading(false));
                }
            }

            return data.valid;
        }).catch(function (err) {
            if (ignoreError) {
              return;
            }

            dispatch(setCouponLoading(false));

            dispatch(setShowError(true));
            dispatch(setShowSuccess(false));
            if (forTaggableCoupon) {
                dispatch(setTaggableCodeError(true));
                dispatch(setTaggableCouponLoading(false));
            }
        });
    }
}

export function applyInviteCoupon(code, forTaggableCoupon = false) {
    return async (dispatch, getState) => {
        const state = getState();

        if (forTaggableCoupon) {
            dispatch(setTaggableCouponLoading(true));
        }

        let creatingReservation = false;
        let errorApplyingInvite = false;
        try {
            // validate the coupon code, get the event data
            const validationResponse = await dispatch(requestInviteCodeValidation(code));
            const validationData = await validationResponse.json();
            if (validationData.valid !== true) {
                throw new Error('Invalid code');
            }

            // create reservation if necessary and attach coupon
            creatingReservation = await dispatch(createReservationIfNotExists());
            if (!reservationActive(getState())) {
                throw new Error('Error creating reservation');
            }

            let alreadyApplied = false;
            getState().coupon.inviteCouponUsages.map(usage => {
                if (usage?.attributes?.code == code) {
                    alreadyApplied = true;
                }
            })
            if (!alreadyApplied) {
                await dispatch(submitInviteCoupon(code));
            }

            // Refetch so invitation_autofill is available for field locking
            const refreshState = getState();
            if (reservationActive(refreshState)) {
                await dispatch(
                    fetchReservation(refreshState.reservation.token, refreshState.reservation.secret, false)
                );
            }

            // if all goes according to plan, put the event data in state
            if (validationData.price_levels) dispatch(setPriceLevels(validationData.price_levels));
            if (validationData.products) dispatch(setProducts(validationData.products));
            if (validationData.bundles) dispatch(setBundles(validationData.bundles));
        } catch (err) {
            errorApplyingInvite = true;
            if (creatingReservation) {
                dispatch(deleteReservation(false));
            }
        }
        if (forTaggableCoupon) {
            dispatch(setTaggableCouponLoading(false));
            if (errorApplyingInvite) {
                dispatch(setTaggableCodeError(true));
            } else {
                dispatch(setTaggableInvitationCodeApplied(true));
            }
        }
    }
}

const requestInviteCodeValidation = code => {
    return (dispatch, getState) => {
        const state = getState();
        const validateParams = serializeToUrl({
            code,
            eventId: getEventId(state),
            listingId: state.ui.listingId,
        });
        return wrappedGet(`${state.ui.apiUrl}/invite-coupon-validation?${validateParams}`);
    }
}

const submitInviteCoupon = code => {
    return (dispatch, getState) => {
        const state = getState();
        const payload = {
            code,
            event_id: getEventId(state),
        };
        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(
            state.reservation.token,
            'invite-coupon-usage',
            payload,
            state.reservation.secret
        );
    }
}

export function sendCouponUsageRequest() {
    return (dispatch, getState) => {
        let state = getState();
        let eventId = getEventId(state);

        let uniqueCodes = [...new Set(state.coupon.codes)];
        let coupons = [];
        uniqueCodes.forEach(uniqueCode => {
           let codeEntry = {
               event_id: +eventId,
               reservation_id: state.reservation.id,
               code: uniqueCode,
               amount: null,
               coupon_type: null,
           }
           // Skip if this code has already been applied to this specific event
           const alreadyUsedForThisEvent = state.coupon.couponData.some(
               usage => usage.code === uniqueCode && +usage.event_id === +eventId
           );
           if (!alreadyUsedForThisEvent) {
               coupons.push(codeEntry);
           }
        });
        let payload = {
            coupons: coupons
        }

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'coupon-usage', payload, state.reservation.secret);
    }
}

export function submitCoupon() {
    return (dispatch, getState) => {
        let state = getState();
        return dispatch(sendCouponUsageRequest()).then((result) => {
            dispatch(setShowSuccess(true));
            return dispatch(fetchReservation(state.reservation.token, state.reservation.secret)).then(() => {
                state = getState();
                if (state.insurance.selected !== "" && isReservationContentFree(state)) {
                    dispatch(setInsurancePolicy(""));
                }
                dispatch(setCouponInput(""));
                return true;
            });
        }).catch((error) => {
            if (error.response.statusCode === 400) {
                // In org listing the same code may be valid for other events — don't wipe it
                // from state on a per-event rejection. In single-event checkout, clear as usual.
                if (!isDynamicListing(getState())) {
                    dispatch(removeCouponCode(state.coupon.code));
                }
                dispatch(addServerErrors(error.response.body.errors));
                dispatch(setShowError(true));
                dispatch(setShowSuccess(false));
                dispatch(setCouponInput(""));
                // The server already rejected this coupon; re-sync couponData so a stale
                // discount line can't linger in the cart after a failed re-apply. If the
                // re-sync itself fails, still resolve false so callers don't get stuck.
                return dispatch(fetchCouponUsage(state.reservation.token, state.reservation.secret, true))
                    .then(() => false)
                    .catch(() => false);
            }
        });
    }
}

function requestPresaleCoupon(state, token, payload, secret, dispatch, getState, eventId, forTaggableCoupon) {
  return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(token, 'presale-coupon-usage', payload, secret).then((result) => {
    dispatch(setIsPresaleApplied(true));
  }).then(() => {
    const reservationFetch = fetchReservation(token, secret)(dispatch, getState);
    // Fetching the reservation after applying the coupon can overwrite the
    // auto-complete customer data on SSO logins, so re-fetch the member here
    // just like login() does after refreshing the reservation.
    if (getIsCheckoutSSO(getState())) {
      Promise.resolve(reservationFetch).then(() => dispatch(refetchMember())).catch(() => {});
    }
    dispatch(setShowError(false));
    dispatch(setShowWarning(false));
    dispatch(setUnlockedPresaleEvent(eventId));
    if (forTaggableCoupon) {
      dispatch(setTaggableAccessCodeApplied(true));
      dispatch(setTaggableCouponLoading(false));
    }
    navigate('/')
    dispatch(setCouponInput(""));
    if (!isDynamicListing(state) && state.ui.uiConfig.listings?.ticketsDisplayType === TICKETS_DISPLAY_LIST) {
      dispatch(setCheckoutOverlay(false));
    }
  }).catch((error) => {
    if (forTaggableCoupon) {
      dispatch(setTaggableAccessCodeApplied(false));
      dispatch(setTaggableCouponLoading(false));
    }
    if (error.response.statusCode === 400) {
      dispatch(setPresaleCode(''));
      dispatch(setIsPresaleValid(false));
      dispatch(setIsPresaleApplied(false));
      dispatch(addServerErrors(error.response.body.errors));
      return Promise.reject("");
    }
  });
}

export function submitPresaleCoupon(forTaggableCoupon = false, coupon = null) {
    return (dispatch, getState) => {
        let state = getState();
        let token = state.reservation?.token;
        let secret = state.reservation?.secret;

        let eventId = getEventId(state);
        var payload = {
            event_id: +eventId,
            code: coupon || state.coupon.presaleCode,
            amount: null,
            coupon_type: null,
            reservation_id: state.reservation.id,
        };

        const resPayload = {
            captureMethod: state.payment.method,
            listingId: state.ui.listingId,
            seller_id: state.event.seller_id,
        }

        if (isDynamicListing(state)) {
          dispatch(addAppliedPresaleCoupon(coupon || state.coupon.presaleCode));
        }

      if(token && secret) {
        return requestPresaleCoupon(state, token, payload, secret, dispatch, getState, eventId, forTaggableCoupon);
      } else {
        return getCheckoutClient(state.ui.apiUrl).createResource('reservations', resPayload, '').then((result) => {
          let secret = result.header['reservation-secret'];
          let token = result.body.data.id;
          setListingItem(state.ui.listingSlug, "secret", secret);
          setListingItem(state.ui.listingSlug, "token", token);
          dispatch(reservationCreated());
          dispatch(setReservationData(secret, result.body.data));
          return requestPresaleCoupon(state, token, payload, secret, dispatch, getState, eventId, forTaggableCoupon);
        }).catch(e => {
        });
      }
    }
}

export function submitPriceLevelCoupon(code, forTaggableCoupon = false) {
    return (dispatch, getState) => {
        let state = getState();
        let token = state.reservation.token;
        let payload = {
            event_id: getEventId(state),
            code: code,
            coupon_type: 11,
        };

        if (token !== '') {
            return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'pl-coupon-usage', payload, state.reservation.secret).then((result) => {
                dispatch(setIsAccessCodeApplied(true));
                dispatch(getHiddenPriceLevels());
                dispatch(setShowError(false));
                dispatch(setShowWarning(false));
                dispatch(setShowAccessCodeSuccess(true));
                if (forTaggableCoupon) {
                    dispatch(setTaggableAccessCodeApplied(true));
                    dispatch(setTaggableCouponLoading(false));
                }
                navigate('/');
                dispatch(setCouponInput(""));
                return fetchReservation(state.reservation.token, state.reservation.secret)(dispatch, getState);
            }).catch((error) => {
                if (forTaggableCoupon) {
                    dispatch(setTaggableCodeError(true));
                    dispatch(setTaggableCouponLoading(false));
                }
                if (error.response.statusCode === 400) {
                    dispatch(addServerErrors(error.response.body.errors));
                    dispatch(setShowError(true));
                    return Promise.reject("");
                }
            });
        } else {
            const resPayload = {
                captureMethod: state.payment.method,
                listingId: state.ui.listingId,
                seller_id: state.event.seller_id,
            }
            return getCheckoutClient(state.ui.apiUrl).createResource('reservations', resPayload, '').then((result) => {
                let secret = result.header['reservation-secret'];
                let token = result.body.data.id;
                setListingItem(state.ui.listingSlug, "secret", secret);
                setListingItem(state.ui.listingSlug, "token", token);
                dispatch(reservationCreated());
                dispatch(setReservationData(secret, result.body.data));
                dispatch(setCouponInput(""));

                return priceLevelCouponUsage(state, token, payload, secret, dispatch, getState, forTaggableCoupon);
            }).catch(e => {
            });
        }
    }
}

function priceLevelCouponUsage(state, token, payload, secret, dispatch, getState, forTaggableCoupon = false) {
    return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(token, 'pl-coupon-usage', payload, secret).then((result) => {
        dispatch(setIsAccessCodeApplied(true));
        dispatch(getHiddenPriceLevels());
        return Promise.resolve(true);
    }).then(() => {
        const reservationFetch = fetchReservation(token, secret)(dispatch, getState);
        // Fetching the reservation after applying the coupon can overwrite the
        // auto-complete customer data on SSO logins, so re-fetch the member here
        // just like login() does after refreshing the reservation.
        if (getIsCheckoutSSO(getState())) {
            Promise.resolve(reservationFetch).then(() => dispatch(refetchMember())).catch(() => {});
        }
        dispatch(setShowError(false));
        dispatch(setShowWarning(false));
        dispatch(setShowAccessCodeSuccess(true));
        navigate('/');
        if (forTaggableCoupon) {
            dispatch(setTaggableAccessCodeApplied(true));
            dispatch(setTaggableCouponLoading(false));
        }
    }).catch((error) => {
        if (forTaggableCoupon) {
            dispatch(setTaggableCodeError(true));
            dispatch(setTaggableCouponLoading(false));
        }
        if (error.response.statusCode === 400) {
            dispatch(clearAccessCodeState());
            dispatch(addServerErrors(error.response.body.errors));
            return Promise.reject("");
        }
    });
}

export const clearAccessCodeState = () => {
    return dispatch => {
        dispatch(setAccessCode(''));
        dispatch(setIsAccessCodeValid(false));
        dispatch(setIsAccessCodeApplied(false));
    }
}

/**
 * Updates price levels and custom inventory configuration after submitting an access code
 */
export function getHiddenPriceLevels() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = serializeToUrl({
            code: state.coupon.accessCode,
            eventId: getEventId(state),
            token: (state.reservation.token !== '') ? state.reservation.token : getListingItem(state.ui.listingSlug, "token")/*localStorage.getItem("token")*/
        });

        return wrappedGet(state.ui.apiUrl + '/price-levels-coupon?' + payload).then((response) => {
            return response.json();
        }).then((data) => {
            dispatch(updatePriceLevels(data.price_levels));
            if (data.inventory) {
                dispatch(setAccessInventory(data.inventory));
            }
        }).catch(function (err) {
        });
    }
}

/**
 * Auto-apply a previously validated access code to the current event.
 * Tries fetching hidden PLs first (works if usage already exists for this event),
 * and only creates a new pl-coupon-usage if no PLs were returned.
 */
export function autoApplyAccessCode(code) {
    return (dispatch, getState) => {
        const suppressCouponErrors = () => {
            dispatch(setShowError(false));
            dispatch(addServerErrors([]));
            dispatch(setShowAccessCodeSuccess(false));
        };

        // Reset access code UI state from any previous event before attempting auto-apply
        dispatch(setShowAccessCodeSuccess(false));
        dispatch(setShowError(false));
        dispatch(addServerErrors([]));

        const state = getState();
        const listingSlug = state.ui.listingSlug;
        const storedToken = getListingItem(listingSlug, "token");
        const storedSecret = getListingItem(listingSlug, "secret");
        const stateToken = state.reservation.token;

        if (storedToken && storedToken !== stateToken) {
            dispatch(setReservationData(storedSecret, { id: storedToken, attributes: {} }));
        } else if (!storedToken && stateToken) {
            dispatch(setReservationData('', { id: '', attributes: {} }));
        }

        const token = storedToken;

        if (token) {
            const payload = serializeToUrl({
                code: code,
                eventId: getEventId(getState()),
                token: token,
            });
            return wrappedGet(state.ui.apiUrl + '/price-levels-coupon?' + payload).then((response) => {
                return response.json();
            }).then((data) => {
                if (data.price_levels && Object.keys(data.price_levels).length > 0) {
                    dispatch(updatePriceLevels(data.price_levels));
                    if (data.inventory) {
                        dispatch(setAccessInventory(data.inventory));
                    }
                    navigate('/');
                } else {
                    return dispatch(submitPriceLevelCoupon(code)).catch(suppressCouponErrors);
                }
            }).catch(() => {
                return dispatch(submitPriceLevelCoupon(code)).catch(suppressCouponErrors);
            });
        } else {
            return dispatch(submitPriceLevelCoupon(code)).catch(suppressCouponErrors);
        }
    }
}

// only sets the discount coupon data for now
export function fetchCouponUsage(token, secret, force = false) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'coupon-usage', secret).then((result) => {
            // force re-syncs couponData from the server even when showSuccess is false.
            if (force || (state.coupon.code !== "" && state.coupon.showSuccess === true)) {
                dispatch(setCouponData(getDiscountCoupons(state, result.body.data)));
            }
            if (getState().reservation.hasReserveCoupon) {
                dispatch(setReserveCouponUsages(getReserveCouponUsages(result.body.data)));
            }
            if (getState().reservation.hasInviteCoupon) {
                dispatch(setInviteCouponUsages(getInviteCouponUsages(result.body.data)));
            }
            return Promise.resolve();
        });
    }
}

const getReserveCouponUsages = couponData => {
    return getCouponUsagesOfType(couponData, 4);
}

const getInviteCouponUsages = couponData => {
    return getCouponUsagesOfType(couponData, 10);
}

const getCouponUsagesOfType = (couponData, type) => {
    return !Array.isArray(couponData) ? [] : couponData.filter(c => +c?.attributes?.coupon_type === type);
}

const getDiscountCoupons = (state, usedCoupons) => {
    let usedDiscountCoupons = [];

    usedCoupons.forEach(usedCoupon => {
        if (usedCoupon['attributes']['coupon_type'] === 2 || usedCoupon['attributes']['coupon_type'] === 7) {
            usedDiscountCoupons.push(usedCoupon.attributes);
        }
    });

    let stateCoupons = [...new Set(state.coupon.codes)];
    // for case-insensitive comparison
    stateCoupons = stateCoupons.map((code) => typeof code === 'string' ? code.toUpperCase() : code);

    let verifiedDiscountCoupons = [];

    usedDiscountCoupons.forEach(usedDiscountCoupon => {
        const compareCode = typeof usedDiscountCoupon.code === 'string' ? usedDiscountCoupon.code.toUpperCase() : usedDiscountCoupon.code;
        // make sure only coupons in the state show up
        if(stateCoupons.includes(compareCode)) {
            let codeEntry = {
                amount: usedDiscountCoupon.amount,
                code: usedDiscountCoupon.code,
                coupon_name: usedDiscountCoupon.coupon_name,
                coupon_offer_id: usedDiscountCoupon.coupon_offer_id,
                coupon_type: usedDiscountCoupon.coupon_type,
                event_coupon_id: usedDiscountCoupon.event_coupon_id,
                event_id: usedDiscountCoupon.event_id,
                reservation_id: usedDiscountCoupon.reservation_id
            }
            verifiedDiscountCoupons.push(codeEntry);
        }
    });


    if (verifiedDiscountCoupons.length) {
        return verifiedDiscountCoupons;
    } else {
        return [];
    }
}

let appliedTaggableCoupon = false;

/**
 * If there is a tagged coupon in the URL, apply it on page load
 * Info on how to handle the tagged code is injected into uiConfig
 * In the listing action.
 */
export const applyTaggableCoupon = (skipPresale = false) => {
    return async (dispatch, getState) => {
        const state = getState();
        const code = state.ui?.uiConfig?.taggableCode;

        if (!code || appliedTaggableCoupon || isKioskMode(state)) {
            return true;
        }

        appliedTaggableCoupon = true;

        if (state.ui?.uiConfig?.hasTaggablePl) {
            if (!state.coupon.accessCode) {
               dispatch(validateCoupon({ code, forTaggableCoupon: true }));
            }
        } else if (state.ui?.uiConfig?.hasTaggableReserve) {
            if (!getReserveCouponUsage(state)) {
                dispatch(setTaggableCouponLoading(true));
                await dispatch(submitReserveCoupon(code));
                dispatch(setTaggableCouponLoading(false));
                if (getState().reservation.hasReserveCoupon) {
                    dispatch(setTaggableReserveCodeApplied(true));
                } else {
                    dispatch(setTaggableCodeError(true));
                }
            }
        } else if (state.ui?.uiConfig?.hasTaggablePresale) {
            if (!skipPresale && showPresaleCouponForm(state)) {
                dispatch(setPresaleCode(code));
                dispatch(validatePresaleCoupon({ reload: null, force: false, forTaggableCoupon: true }));
            }
        } else if (state.ui?.uiConfig?.hasTaggableInvite) {
            dispatch(applyInviteCoupon(code, true));
        } else if (state.ui?.uiConfig?.hasTaggableDiscount) {
            // code has already been validated, but will be applied after
            // reservation is created. just show the success message
            dispatch(setTaggableDiscountCodeApplied(true));
        }
    }
}
